import React from 'react';
import Image from 'next/image';
import { SubCategoriesResponse } from '@api/fetchers/prime/types';
import {
  MobilePrimeBanner,
  PrimeLogoWrapper,
  MobileSearchBar,
  SearchIcon,
  SearchPlaceholder,
  MobilePillsWrapper,
  Pill
} from './PrimeHome.styles';

interface PrimeHomeMobileHeaderProps {
  subCategories: SubCategoriesResponse;
  selectedSubCategory: string;
  onSelectSubCategory: (uid: string) => void;
  onSearchClick: () => void;
}

const PrimeHomeMobileHeader: React.FC<PrimeHomeMobileHeaderProps> = ({
  subCategories,
  selectedSubCategory,
  onSelectSubCategory,
  onSearchClick
}) => {
  if (!subCategories?.length) {
    return null;
  }

  return (
    <MobilePrimeBanner>
      <PrimeLogoWrapper>
        <Image
          src="/static/images/prime/prime-logo.svg"
          alt="Prime"
          width={121}
          height={42}
        />
      </PrimeLogoWrapper>
      <MobileSearchBar onClick={onSearchClick}>
        <SearchIcon
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.333 12.667A5.333 5.333 0 1 0 7.333 2a5.333 5.333 0 0 0 0 10.667ZM14 14l-2.9-2.9"
            stroke="rgba(255,255,255,0.5)"
            strokeWidth="1.33"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </SearchIcon>
        <SearchPlaceholder>Search for a lesson</SearchPlaceholder>
      </MobileSearchBar>
      <MobilePillsWrapper>
        {subCategories.map((subCategory) => {
          const isSelected = selectedSubCategory === subCategory.uid;
          return (
            <Pill
              key={subCategory.uid}
              $selected={isSelected}
              onClick={() => onSelectSubCategory(subCategory.uid)}
            >
              {subCategory.name}
            </Pill>
          );
        })}
      </MobilePillsWrapper>
    </MobilePrimeBanner>
  );
};

export default PrimeHomeMobileHeader;
